import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import ErrorMessage from "../../components/ui/ErrorMessage";
import { useAddQuizMarkMutation } from "../../features/quizMark/quizMarkAPI";
import { useGetQuizzesOfVideoQuery } from "../../features/quizzes/quizzesAPI";
import { useGetVideoQuery } from "../../features/videos/videosAPI";

function StudentQuiz() {
  const { video_id } = useParams();
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const {
    data: video,
    isLoading: isVideoLoading,
    isError: isVideoError,
    isSuccess: isVideoSuccess,
  } = useGetVideoQuery(video_id);

  const {
    data: quizzes,
    isLoading: isQuizzesLoading,
    isError: isQuizzesError,
    isSuccess: isQuizzesSuccess,
  } = useGetQuizzesOfVideoQuery(video_id);

  const [
    addQuizMark,
    {
      isLoading: addMarkLoading,
      isError: addMarkError,
      isSuccess: addMarkSuccess,
    },
  ] = useAddQuizMarkMutation();

  // const correctAnswers = useRef({});
  const studentAnswer = useRef({});
  useEffect(() => {
    // let correctAnswerObject = {};
    let studentAnswerObject = {};
    //initialize to have quiz objects
    quizzes?.forEach((quiz) => {
      // correctAnswerObject[quiz?.id] = {};
      studentAnswerObject[quiz?.id] = {};
    });

    //initialize to have option's correct state in the quiz object

    quizzes?.forEach((quiz) => {
      quiz?.options?.forEach((option) => {
        // correctAnswerObject[quiz?.id][option?.id] = option.isCorrect;
        if (option.isCorrect) {
          studentAnswerObject[quiz?.id][option?.id] = "incorrect";
        } else {
          studentAnswerObject[quiz?.id][option?.id] = "correct";
        }
      });
    });

    // correctAnswers.current = correctAnswerObject;
    studentAnswer.current = studentAnswerObject;
  }, [quizzes]);

  // const [obtainedMark, setObtainedMark] = useState(0);

  function handleChange(event, ques_id, option) {
    let studentAnswerCopy = { ...studentAnswer.current };

    if (event.target.checked === option.isCorrect) {
      studentAnswerCopy[ques_id][option?.id] = "correct";
    } else {
      studentAnswerCopy[ques_id][option?.id] = "inCorrect";
    }

    studentAnswer.current = studentAnswerCopy;
  }

  function handleSubmit(event) {
    event.preventDefault();
    let obtainedMark = 0;
    const quizIds = Object.keys(studentAnswer.current);
    quizIds.forEach((quizId) => {
      const answersOfThisQuiz = Object.values(studentAnswer.current[quizId]);
      const quesAnsweredCorrectly = answersOfThisQuiz?.every(
        (ans) => ans === "correct"
      );
      if (quesAnsweredCorrectly) obtainedMark += 5;
    });
    const totalQuiz = quizzes?.length;
    const totalMark = totalQuiz * 5;

    //prepare payload
    const payload = {
      student_id: user?.id,
      student_name: user?.name,
      video_id: video?.id,
      video_title: video?.title,
      totalQuiz: totalQuiz,
      totalCorrect: obtainedMark / 5,
      totalWrong: (totalMark - obtainedMark) / 5,
      totalMark: totalMark,
      mark: obtainedMark,
    };

    addQuizMark(payload);
  }

  useEffect(() => {
    if (addMarkSuccess) {
      return navigate("/leaderboard");
    }
  }, [addMarkSuccess, navigate]);

  let content = null;
  if (isQuizzesLoading || isVideoLoading) content = "Loading...";
  else if (isQuizzesError || isVideoError) content = "Error fetching Quizzes!";
  else if (isQuizzesSuccess && isVideoSuccess && quizzes?.length === 0)
    content = "No Quiz Found!";
  else if (isQuizzesSuccess && isVideoSuccess && quizzes?.length > 0)
    content = quizzes?.map((quiz, quizNo) => (
      <div className="quiz" key={quiz?.id}>
        <h4 className="question">{quiz?.question}</h4>
        <form className="quizOptions" onSubmit={handleSubmit}>
          {/* <!-- Option 1 --> */}
          {quiz?.options?.map((option, optionNo) => (
            <label for={`option${optionNo + 1}_q${quizNo + 1}`}>
              <input
                type="checkbox"
                id={`option${optionNo + 1}_q${quizNo + 1}`}
                onChange={(event) => handleChange(event, quiz?.id, option)}
              />
              {option?.option}
            </label>
          ))}
        </form>
      </div>
    ));

  return (
    <section className="py-6 bg-primary">
      <div className="mx-auto max-w-7xl px-5 lg:px-0">
        <div className="mb-8">
          <h1 className="text-2xl font-bold">
            Quizzes for "Debounce Function in JavaScript - JavaScript Job
            Interview question"
          </h1>
          <p className="text-sm text-slate-200">
            Each question contains 5 Mark
          </p>
        </div>
        <div className="space-y-8 ">{content}</div>
        {addMarkError && <ErrorMessage />}
        <button
          className="px-4 py-2 rounded-full bg-cyan block ml-auto mt-8 hover:opacity-90 active:opacity-100 active:scale-95"
          type="submit"
          onClick={handleSubmit}
          disabled={addMarkLoading}
        >
          Submit
        </button>
      </div>
    </section>
  );
}

export default StudentQuiz;
